import store from "./store";

const getPracticeId = () => {
  const state = store.getState();
  return state?.auth?.authData?.selected_practice?.toString();
};

export default getPracticeId;
